import { Component, OnInit } from '@angular/core';
import { LiftStatsComponent } from '../lift-stats/lift-stats.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-lift-stats-r11',
	templateUrl: './lift-stats-r11.component.html',
	styleUrls: ['../lift-stats/lift-stats.component.css']
})
export class LiftStatsR11Component extends LiftStatsComponent implements OnInit {
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit() {
		super.ngOnInit();
	}
}
